





































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  props: {
    createCheck: {
      type: Function,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      showBirthdayPicker: false,
      birthday: '',
      phoneNumber: ''
    }
  },
  computed: {
    ...mapGetters('language', ['getLanguage']),
    ...mapGetters('results', ['getChecksCounter'])
  },
  methods: {
    buildCheckInput (): Record<string, string> {
      return {
        birthday: this.birthday,
        phone_number: this.phoneNumber
      }
    }
  }
})
